import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { publicShareMeta, publicSharePdfUrl, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileDown, ShieldCheck, AlertTriangle } from "lucide-react";

const LABELS = { invoice: "Invoice", quote: "Quotation", payslip: "Payslip", report: "Work Report", statement: "Statement", receipt: "Receipt" };

export default function PublicView() {
  const { token } = useParams();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    publicShareMeta(token).then(setMeta).catch((e) => setError(apiError(e)));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#0B132B] flex items-center justify-center p-6" data-testid="share-error">
        <div className="bg-white rounded-2xl p-10 max-w-md text-center">
          <div className="w-14 h-14 rounded-2xl bg-rose-50 flex items-center justify-center mx-auto text-rose-500"><AlertTriangle className="w-7 h-7" /></div>
          <h1 className="font-bold text-xl text-[#0B132B] mt-4">Link unavailable</h1>
          <p className="text-slate-500 text-sm mt-2">{error}</p>
        </div>
      </div>
    );
  }
  if (!meta) return <div className="min-h-screen bg-[#0B132B] flex items-center justify-center text-slate-300">Loading…</div>;

  return (
    <div className="min-h-screen bg-[#0B132B]" data-testid="public-view">
      <header className="px-6 py-4 flex items-center justify-between border-b border-white/10">
        <div className="flex items-center gap-3">
          {meta.logo_url ? <img src={meta.logo_url} alt="" className="h-9 w-9 rounded-lg object-cover" /> : null}
          <div>
            <div className="text-white font-bold leading-tight" data-testid="share-business">{meta.business_name}</div>
            <div className="text-[#D4AF37] text-xs tracking-widest uppercase">{LABELS[meta.doc_type] || "Document"}</div>
          </div>
        </div>
        <a href={publicSharePdfUrl(token, true)}>
          <Button className="bg-[#D4AF37] hover:bg-[#c39f2f] text-[#0B132B] font-semibold" data-testid="share-download-btn"><FileDown className="w-4 h-4 mr-1.5" /> Download PDF</Button>
        </a>
      </header>
      <div className="max-w-4xl mx-auto p-4">
        <div className="text-slate-300 text-sm mb-3 flex items-center gap-1.5" data-testid="share-label"><ShieldCheck className="w-4 h-4 text-emerald-400" /> {meta.label || LABELS[meta.doc_type]} · secure shared document</div>
        <iframe title="document" src={publicSharePdfUrl(token)} className="w-full h-[80vh] rounded-xl bg-white border border-white/10" data-testid="share-iframe" />
      </div>
    </div>
  );
}
